import config from '../../config/config.js'
import interfaceApi from './interface.js'
import requestService from './request.js'
import router from '../../router'
import store from '../../store/index.js'
import i18n from '@/api/i18n'

// 公用方法和变量封装
const commonFunc = {
    // 全局统一控制打印log日志--部署版本前请务必注释打印代码
    myConsole(logObj) {
        // console.log(logObj)
    },
    // 全局统一 debugger --部署版本前请务必注释该行
    myDebugger() {
        // debugger
    },
    // 判断是否定义或存在
    isDefine(para) {
        let paraType = typeof para
        if (para === 'undefined' || para === 'null' || para === '' || para === '[]' || para === null || para === undefined) {
            return false
        } else if (paraType === 'number' || paraType === 'object' || paraType === 'string' || paraType === 'function' || paraType === 'boolean') {
            return true
        } else {
            for (var o in para) {
                return true
            }
            return false
        }
    },
    // 获取对象是否是指定的对象 使用：commonFunc.Type.isArray(value)
    Type: (function() {
        var type = {}
        var typeArr = [
            'String',
            'Object',
            'Number',
            'Array',
            'Undefined',
            'Function',
            'Null',
            'Symbol'
        ]
        for (var i = 0; i < typeArr.length; i++) {
            (function(name) {
                type['is' + name] = function(obj) {
                    return Object.prototype.toString.call(obj) === '[object ' + name + ']'
                }
            })(typeArr[i])
        }
        return type
    })(),
    // 获取元素是否存在或数组中的定位
    getArrayIndexByValue(val, ArrayObj) {
        for (var i = 0; i < ArrayObj.length; i++) {
            if (JSON.stringify(ArrayObj[i]) === JSON.stringify(val)) {
                return i
            }
        }
        return -1
    },
    // 根据元素值在数组中删除某个元素
    arrayRemoveByValue(val, ArrayObj) {
        var index = this.getArrayIndexByValue(val, ArrayObj)
        if (index > -1) {
            ArrayObj.splice(index, 1)
        }
        return ArrayObj
    },
    /**
   * commonRequest 请求接口 （不用store）
   * @param  {string} type   请求接口类型
   * @param  {string} requestType  请求类型
   * @param  {object} condition  请求参数
   * @param  {string} url  请求接口
   * @param  {bealoon} notForm  不是表单
   * @return {object}  结果
   */
    async commonRequest(requestType, url, type, condition, notForm) {
        console.log('url:' + url)
        let dataParams
        let res
        // 得到组装好的接口数据
        if (type && condition) {
            dataParams = interfaceApi.getParams(type, condition)
        }
        // requestType = requestType.toLowerCase();
        // 接收api返回来的结果
        if (requestType == 'get' || requestType == 'GET') {
            res = await requestService.get(config.APISERVER.host + url, dataParams)
        } else if (requestType == 'upLoadFile') {
            res = await requestService.upLoadFile(config.APISERVER.host + url, dataParams)
        } else if (requestType == 'post' || requestType == 'POST') {
            if (notForm == true) {
                res = await requestService.post(config.APISERVER.host + url, dataParams)
            } else {
                res = await requestService.post(config.APISERVER.host + url, dataParams, 'form') //默认form
            }
        } else if (requestType == 'downloadFile') {
            res = await requestService.downloadFile(config.APISERVER.host + url, dataParams)
        }

        return new Promise(function(resolve, reject) {
            if (res.code === '00001') {
                resolve(res)
            } else {
                reject(res)
                if (res.code === '00003') {
                    // 获取并设置相关本地数据源
                    setTimeout(()=>{
                        store.dispatch('userInfo/doClearUserInfo')
                        router.push({path: '/'})
                        window.location.reload()//清空路由缓存
                    }, 2000)
                }
            }
        });
    },

    //获得数据字典详情 sureCode 为true value返回code, 否者value也为name
    getDataDicList(code, sureCode) {
        return new Promise((resolve, reject) => {
            this.commonRequest('get', '/system/data_dictionary/list/dicCode', 'getDicLineByCode', {dicCode: code}).then(res => {
                let arr = []
                if(res.obj && res.obj.length) {
                    if(sureCode) {
                        res.obj.forEach((o, i) => {
                            arr.push({label: o.dicName, value: o.dicCode})
                        })
                    } else {
                        res.obj.forEach((o, i) => {
                            arr.push({label: o.dicName, value: o.dicName})
                        })
                    }
                }
                resolve(arr)
            }).catch(res => {
                reject(res)
            })
        })
    },

    //获得值集详情
    getValueSetList(code, sureCode) {
        return new Promise((resolve, reject) => {
            this.commonRequest('get', '/configValuesetLine/query/contentList', 'getValueSetLineByCode', {valuesetCode: code}).then(res => {
                let arr = []
                if(res.obj && res.obj.length) {
                    if(sureCode) {
                        res.obj.forEach((o, i) => {
                            arr.push({label: o.valuesetLineContent, value: o.valuesetLineCode})
                        })
                    } else {
                        res.obj.forEach((o, i) => {
                            arr.push({label: o.valuesetLineContent, value: o.valuesetLineContent})
                        })
                    }
                }
                resolve(arr)
            }).catch(res => {
                reject(res)
            })
        })
    },

    // 解决 js 加-减-乘-除-四则运算精度问题
    // 除 (2.11/100)
    amcDiv(arg1, arg2) {
        let t1 = 0,t2 = 0,r1,r2;
        try {
            t1 = arg1.toString().split(".")[1].length
        } catch (e) {}
        try {
            t2 = arg2.toString().split(".")[1].length
        } catch (e) {}
        r1 = Number(arg1.toString().replace(".", ""))
        r2 = Number(arg2.toString().replace(".", ""))
        return (r1 / r2) * Math.pow(10, t2 - t1)
    },
    // 乘 (1.11*100)
    amcMul(arg1, arg2) {
        let m = 0,s1 = arg1.toString(),s2 = arg2.toString();
        try {
            m += s1.split(".")[1].length
        } catch (e) {}
        try {
            m += s2.split(".")[1].length
        } catch (e) {}
        return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)
    },
    // 加 (1.11+1)
    amcAdd(arg1, arg2) {
        let r1,r2,m;
        try {
            r1 = arg1.toString().split(".")[1].length
        } catch (e) {
            r1 = 0
        }
        try {
            r2 = arg2.toString().split(".")[1].length
        } catch (e) {
            r2 = 0
        }
        m = Math.pow(10, Math.max(r1, r2))
        return (arg1 * m + arg2 * m) / m
    },
    // 减 (1.11-1)
    amcSub(arg1, arg2) {
        let r1,r2,m,n;
        try {
            r1 = arg1.toString().split(".")[1].length
        } catch (e) {
            r1 = 0
        }
        try {
            r2 = arg2.toString().split(".")[1].length
        } catch (e) {
            r2 = 0
        }
        m = Math.pow(10, Math.max(r1, r2))
        //last modify by deeka
        //动态控制精度长度
        n = (r1 >= r2)?r1:r2
        return ((arg1 * m - arg2 * m) / m).toFixed(n)
    },
    //千分位
    format (num) {
        return ((num?num:0) + '').replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,');
    },

    //判断上传文件大小10M格式 xlsx
    checkFileTypeAndSize(param) {
        const isXLSX = param.raw.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        const isLt10M = param.size / 1024 / 1024 < 10
        if (!isXLSX) {
            return '上传文件只能是 xlsx 格式 !'
        }
        if (!isLt10M) {
            return '上传文件大小不能超过 10MB !'
        }
        return false
    },
    //根据拿到的菜单匹配已有的菜单
    recursionRouter(userRouter = [], allRouter = []) {
        var realRoutes = []
        allRouter.forEach((v, i) => {
            userRouter.forEach((item, index) => {
                if (item.menuCode === v.code) {
                    v.buttonList = []
                    if(item.buttonList && item.buttonList.length) {
                        item.buttonList.forEach((o,i)=>{
                            v.buttonList.push(o.buttonCode)
                        })
                    }
                    if (item.childrenList && item.childrenList.length > 0) {
                        v.children = this.recursionRouter(item.childrenList, v.children)
                    }
                    realRoutes.push(v)
                }
            })
        })
        return realRoutes
    },

    //处理值
    alterValue(value, list) {
        let valueFlag = ''
        list.forEach((o,i)=>{
            if(o.value == value) {
                valueFlag = o.label
            }
        })
        if(value == '应付利息-结转') {
            valueFlag = '应付利息/Interest Payable'
        }

        return valueFlag || value
    }
}

export default commonFunc



// WEBPACK FOOTER //
// ./src/api/common/common.js